import _ from 'lodash';

export const getTotalPatternFt = ({ cropSequence }) =>
  _.sum(cropSequence.map(({ spacingFt }) => spacingFt));

export const cropVarietyIdForPattern = (
  patternId,
  inRowPatternsMap,
  cropId,
) => {
  const pattern = inRowPatternsMap[patternId];
  // Assumes that all points of the same crop in the pattern have the same crop variety
  const inRowPatternCrop = pattern?.cropSequence?.find(
    (irpc) => irpc.crop.id === cropId,
  );
  return inRowPatternCrop?.cropVariety?.id;
};
